// extracted by mini-css-extract-plugin
module.exports = {"HowItem":"HowItem_HowItem__20kmI","LastChild":"HowItem_LastChild__2M5as"};